<template>
  <div style="padding: 0.22rem; padding-bottom: 0">
    <div style="display: flex; border-bottom: 1px solid #e5e6eb">
      <!-- @click="leftGoto('/materialUpload')" -->
      <div
        class="top_tab"
        style="margin-left: 0"
        @click="tabClick('VIDEO')"
        :class="top_tabShow == 'VIDEO' ? 'top_tab_select' : ''"
      >
        视频素材
      </div>
      <!-- @click="leftGoto('/musicUpload')" -->
      <div
        class="top_tab"
        @click="tabClick('MUSIC')"
        :class="top_tabShow == 'MUSIC' ? 'top_tab_select' : ''"
      >
        音乐素材
      </div>
      <!-- @click="leftGoto('/pictureUpload')" -->
      <div
        class="top_tab"
        @click="tabClick('IMAGE')"
        :class="top_tabShow == 'IMAGE' ? 'top_tab_select' : ''"
      >
        图片素材
      </div>
    </div>
  </div>
</template>
<!-- IMAGE, MUSIC, VIDEO -->
<script setup lang="ts">
import {
  defineComponent,
  ref,
  onMounted,
  watchEffect,
  inject,
  provide,
  getCurrentInstance,
} from "vue";
document.title = "标识山西-我的素材";
import { useRouter } from "vue-router";
const router = useRouter();
//直接跳转

const leftGoto = (type) => {
  router.push(type);
};
defineProps({
  top_tabShow: String,
});
const instance = getCurrentInstance();
const tabClick = (type) => {
  instance?.emit("tabClick", type);
};
</script>

<style scoped>
.top_title {
  font-size: 0.18rem;
  margin-bottom: 0.2rem;
  color: #86909c;
}

.top_tab {
  font-size: 0.14rem;
  margin-bottom: 0.2rem;
  color: #333333;
  margin-left: 0.4rem;
  cursor: pointer;
}

.top_tab_select {
  color: #C01A26;
}
</style>
